import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import { deepEqual } from 'fast-equals';

import { IconButtonComponent } from '../../common/button/components/icon-button/icon-button.component';
import { ButtonLoadingDirective } from '../../common/button/directives/button-loading/button-loading.directive';
import { GroupComponent } from '../../common/group/group.component';
import { IconColorDirective } from '../../common/icon/directives/icon-color.directive';
import { IconComponent } from '../../common/icon/icon.component';
import { ListSortableFormComponent } from '../list-sortable-form/list-sortable-form.component';

export type SortableItem = { position: number; name?: string; title?: string; id: number };

@Component({
  selector: 'rt-list-sortable-item',
  templateUrl: './list-sortable-item.component.html',
  styleUrls: ['./list-sortable-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonLoadingDirective,
    GroupComponent,
    IconButtonComponent,
    IconColorDirective,
    IconComponent,
    ListSortableFormComponent,
  ],
})
export class ListSortableItemComponent {
  @Input() public title: string;
  @Input() public item: SortableItem;
  @Input('isEdited') public titleEditorOpen: boolean = false;
  @Input() public removable: boolean = true;
  @Input() public renamable: boolean = true;
  @Input() public processing: boolean = false;

  @Input()
  public set editable(value: boolean) {
    this.removable = value;
    this.renamable = value;
  }

  public get editable(): boolean {
    return this.removable || this.renamable;
  }

  @Output() public nameChange: EventEmitter<string> = new EventEmitter();
  @Output() public delete: EventEmitter<SortableItem> = new EventEmitter();
  public isDeleteLoading: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('item' in changes) {
      const item = changes.item;
      if (this.titleEditorOpen && item && !item.firstChange) {
        const { currentValue, previousValue } = item;
        if (!deepEqual(currentValue, previousValue)) {
          this.titleEditorOpen = false;
        }
      }
    }
  }

  public onDeleteItemClick(): void {
    this.isDeleteLoading = true;
    this.delete.emit(this.item);
    this.cdRef.detectChanges();
  }

  public onEditItemClick(): void {
    this.titleEditorOpen = true;
    this.cdRef.detectChanges();
  }

  public onEditName(newName: string): void {
    this.nameChange.emit(newName);
  }

  public onCancelClick(): void {
    this.titleEditorOpen = false;
    this.cdRef.detectChanges();
  }
}
